import { MAX_IMG_SIZE, MAX_VIDEO_SIZE, MAX_DOCUMENT_SIZE } from './users';
import { ROUTES } from './routes';

export const MAX_FILES_UPLOAD_NUMBER = 8;

export const MIN_INVESTED_AMOUNT = 20; // if invested less than 20%, then not enough space to display 'funded'

export const statutDocumentUrl =
  'https://wecantokenize-test.s3.amazonaws.com/docs/Deed%20of%20incorporation.pdf';

export const STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  ON_SALE: 'ON_SALE',
  ENDED: 'ENDED',
  COMING_SOON: 'COMING_SOON',
  WAITING_LIST: 'WAITING_LIST',
  CLOSED: 'CLOSED',
};

export const STATUSES_TITLES = {
  [STATUSES.PENDING]: 'Pending',
  [STATUSES.APPROVED]: 'Approved',
  [STATUSES.ON_SALE]: 'Open',
  [STATUSES.ENDED]: 'Closed',
  [STATUSES.COMING_SOON]: 'Coming Soon',
  [STATUSES.WAITING_LIST]: 'Waiting List',
  [STATUSES.CLOSED]: 'Closed',
};

export const STEPS = {
  TYPE: 0,
  ASSETS_SETTINGS: 1,
  BANK_INFO: 2,
  ASSETS_INFORMATION: 3,
};

export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const VIDEO_MIME_TYPES = ['video/webm', 'video/mp4'];
export const DOCUMENT_MIME_TYPES = ['application/pdf'];
export const JSON_MIME_TYPE = 'application/json';

export const IMAGE_TYPES = ['.jpeg', '.jpg', '.png'];
export const VIDEO_TYPES = ['.webm', '.mp4'];
export const DOCUMENT_TYPES = ['.pdf'];

export const ASSET_FILES = {
  logoImage: 'logoImage',
  coverImage: 'coverImage',
  assetImages: 'assetImages',
  assetDocuments: 'assetDocuments',
  assetVideo: 'assetVideo',
  // TODO: need those docs?
  assetMemorandum: 'assetMemorandum',
  assetSubscription: 'assetSubscription',
};

export const ASSET_FILES_MAX_SIZE = {
  logoImage: MAX_IMG_SIZE,
  coverImage: MAX_IMG_SIZE,
  assetImages: MAX_IMG_SIZE,
  assetDocuments: MAX_DOCUMENT_SIZE,
  assetVideo: MAX_VIDEO_SIZE,
  assetMemorandum: MAX_DOCUMENT_SIZE,
  assetSubscription: MAX_DOCUMENT_SIZE,
};

export const FILE_MIME_TYPES = {
  logoImage: IMAGE_MIME_TYPES,
  coverImage: IMAGE_MIME_TYPES,
  assetImages: IMAGE_MIME_TYPES,
  assetDocuments: DOCUMENT_MIME_TYPES,
  assetVideo: VIDEO_MIME_TYPES,
  assetMemorandum: DOCUMENT_MIME_TYPES,
  assetSubscription: DOCUMENT_MIME_TYPES,
};

export const FILE_TYPES = {
  logoImage: IMAGE_TYPES,
  coverImage: IMAGE_TYPES,
  assetImages: IMAGE_TYPES,
  assetDocuments: DOCUMENT_TYPES,
  assetVideo: VIDEO_TYPES,
  assetMemorandum: DOCUMENT_TYPES,
  assetSubscription: DOCUMENT_TYPES,
  signedTransaction: JSON_MIME_TYPE,
};

export const RESULTS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
};

export const STEP_INFO = {
  [STEPS.TYPE]: {
    name: 'Type of asset',
    title: 'What kind of asset do you want to advertise?',
  },
  [STEPS.ASSETS_SETTINGS]: {
    name: 'Asset specifications',
    title: 'Asset specifications',
  },
  [STEPS.BANK_INFO]: {
    name: 'Bank information',
    title: 'Provide your bank information',
  },
  [STEPS.ASSETS_INFORMATION]: {
    name: 'Asset information',
    title: 'Edit your page',
  },
};

export const ASSET_TYPES = {
  REAL_ESTATE: 'REAL_ESTATE',
  EQUITY: 'EQUITY',
  INVESTMENT_FUND: 'INVESTMENT_FUND',
};

export const ASSET_TYPE_LABELS_RATE = {
  [ASSET_TYPES.REAL_ESTATE]: 'Expected IRR',
  [ASSET_TYPES.EQUITY]: 'Interest rate',
};

export const ASSET_TYPE_LABELS_PERIOD = {
  [ASSET_TYPES.REAL_ESTATE]: 'Expected holding period',
  [ASSET_TYPES.EQUITY]: 'Holding period',
};

export const ASSET_TYPES_NAMES = {
  [ASSET_TYPES.REAL_ESTATE]: 'Property Investment',
  [ASSET_TYPES.EQUITY]: 'Fixed-term loan',
};

export const PROJECT_TYPES = {
  OPEN: ROUTES.PROJECT.split('/')[1], // projects
  CLOSED: ROUTES.CLOSED_PROJECT.split('/')[1], // closed-projects
};

export const COUNTRIES = [
  { value: 'AX', label: 'Aland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, St. Eustatius, Saba' },
  { value: 'BA', label: 'Bosnia' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'VG', label: 'British Virgin Isles' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'IC', label: 'Canary Islands' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: "China, People's Republic of" },
  { value: 'CO', label: 'Colombia' },
  { value: 'CG', label: 'Congo' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CW', label: 'Curacao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'CD', label: 'Democratic Republic of Congo' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'EN', label: 'England' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FO', label: 'Faeroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HO', label: 'Holland' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland, Republic of' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'CI', label: 'Ivory Coast' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KV', label: 'Kosovo' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macau' },
  { value: 'MK', label: 'Macedonia (Fyrom)' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MP', label: 'N. Mariana Islands' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'NB', label: 'Northern Ireland' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Reunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SF', label: 'Scotland' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KR', label: 'South Korea' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'C3', label: 'St. Croix' },
  { value: 'UV', label: 'St. John' },
  { value: 'KN', label: 'St. Kitts and Nevis' },
  { value: 'LC', label: 'St. Lucia' },
  { value: 'SX', label: 'St. Maarten and St. Martin' },
  { value: 'VL', label: 'St. Thomas' },
  { value: 'VC', label: 'St. Vincent/Grenadines' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'VI', label: 'US Virgin Islands' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City State' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'WL', label: 'Wales' },
  { value: 'WF', label: 'Wallis and Futuna Islands' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];
